import store from '@/store'

export default [
  {
    path: '/rate-informations',
    name: 'rate-information',
    meta: { requiresAuth: true },
    component: () => import('@/pages/rate-information/index.vue')
  },
  {
    path: '/rate-informations/:id',
    name: 'rate-information-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/rate-information/index.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('rateInformation/find', to.params.id)
      next()
    }
  }
]
